import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { RentPaymentNotificationSettings } from '~/swagger/settings/Api';

const rentPaymentNotificationsSettingsUrl = `${envConfig.service.settings}/company-portal/settings/rentpaymentnotification`;
const rentPaymentNotificationsSettingsCompanyUrl = `${rentPaymentNotificationsSettingsUrl}/company`;

export class rentPaymentNotificationsSettingsRepository extends BaseRestRepository {
  public async changeRentPaymentNotificationsSettings(payload: RentPaymentNotificationSettings) {
    const url = rentPaymentNotificationsSettingsCompanyUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getAllRentPaymentNotificationsSettings() {
    const url = `${rentPaymentNotificationsSettingsUrl}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateRentPaymentNotificationsSettingsByLevel(level: string, levelId: string, payload: RentPaymentNotificationSettings) {
    const url = rentPaymentNotificationsSettingsUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteRentPaymentNotificationsSettingsByLevel(level: string, levelId: string) {
    const url = `${rentPaymentNotificationsSettingsUrl}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
